import { render, staticRenderFns } from "./assignedUsers.vue?vue&type=template&id=c2b6987c&functional=true&"
import script from "./assignedUsers.vue?vue&type=script&lang=js&"
export * from "./assignedUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_fb85a9817f99bdf862e5e3a442a1fb91/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports